import React from "react";
import TextInput from "./TextInput";

export default props => {
  switch (props.type) {
    case "email":
    case "text":
    case "password":
      return <TextInput {...props} />;
    default:
      throw new Error(`No form input of type ${props.type}`);
  }
};
